import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=636d9962&scoped=true&"
import script from "./editDialog.vue?vue&type=script&lang=js&"
export * from "./editDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d9962",
  null
  
)

export default component.exports